import React, { useState } from 'react';
import toast from 'react-hot-toast';

function Inregistrare({ inchideModal, mergiLaLogare, onLoginSuccess }) {
  const [arataFormularEmail, setArataFormularEmail] = useState(false);
  const [arataParola, setArataParola] = useState(false);
  
  const [dateFormular, setDateFormular] = useState({
    first_name: '',
    last_name: '',
    email: '',
    parola: ''
  });

  const actualizareDate = (e) => {
    setDateFormular({
      ...dateFormular,
      [e.target.name]: e.target.value
    });
  };

  const trimiteDate = async (e) => {
    e.preventDefault();

    try {
      const raspuns = await fetch('https://tranzitio.onrender.com/api/autentificare/inregistrare', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          nume: `${dateFormular.first_name} ${dateFormular.last_name}`,
          email: dateFormular.email,
          parola: dateFormular.parola
        })
      });

      const date = await raspuns.json();

      if (raspuns.ok) {
        toast.success('Cont creat cu succes pe TRANZITIO! Acum te poti loga.');
        mergiLaLogare(); 
      } else {
        toast.error(date.mesaj);
      }
    } catch (eroare) {
      toast.error('A aparut o eroare la conectarea cu serverul.');
    }
  };

  return (
    <div className="fixed inset-0 z-[100] bg-black/60 backdrop-blur-sm flex items-center justify-center p-4">
      <div className="max-w-[440px] w-full bg-white rounded-2xl shadow-2xl relative overflow-hidden transition-all duration-300">
        
        <button
          onClick={inchideModal}
          className="absolute top-5 right-5 p-2 text-gray-500 hover:bg-gray-100 rounded-full transition"
        >
          <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>

        <div className="px-8 pt-12 pb-10">
          
          {!arataFormularEmail ? (
            <div className="animate-fade-in">
              <h2 className="text-3xl font-extrabold text-[#3a3a44] text-center mb-2">Inregistrare</h2>
              <p className="text-center text-gray-500 mb-8 font-medium">
                Ai deja un cont? <span onClick={mergiLaLogare} className="text-[#008f9c] font-bold hover:underline cursor-pointer">Logare</span>
              </p>

              <div className="space-y-3.5">
                <button className="w-full flex items-center justify-center gap-3 bg-white border border-gray-300 rounded-lg px-4 py-3 text-[#3a3a44] font-bold hover:bg-gray-50 transition">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4"/><path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.16v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853"/><path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.16C1.43 8.55 1 10.22 1 12s.43 3.45 1.16 4.93l3.68-2.84z" fill="#FBBC05"/><path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.16 7.07l3.68 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335"/></svg>
                  Continua cu Google
                </button>
                <button className="w-full flex items-center justify-center gap-3 bg-white border border-gray-300 rounded-lg px-4 py-3 text-[#3a3a44] font-bold hover:bg-gray-50 transition">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="black" xmlns="http://www.w3.org/2000/svg"><path d="M16.34 10.59c-.02-2.58 2.1-3.83 2.2-3.89-1.2-1.76-3.07-2-3.7-2.04-1.58-.16-3.08.93-3.88.93-.8 0-2.04-.91-3.34-.89-1.68.02-3.23.98-4.1 2.5-1.76 3.05-.45 7.57 1.28 10.05.84 1.21 1.84 2.57 3.16 2.52 1.28-.05 1.76-.83 3.32-.83 1.54 0 1.98.83 3.34.8 1.4-.02 2.26-1.23 3.1-2.44 1-1.46 1.4-2.87 1.43-2.95-.03-.01-2.77-1.06-2.81-3.76zM15.02 5.4c.7-.85 1.17-2.04 1.04-3.21-1.01.04-2.25.67-2.97 1.52-.57.66-1.13 1.88-.98 3.03 1.12.09 2.21-.49 2.91-1.34z"/></svg>
                  Continua cu Apple
                </button>
                <button className="w-full flex items-center justify-center gap-3 bg-white border border-gray-300 rounded-lg px-4 py-3 text-[#3a3a44] font-bold hover:bg-gray-50 transition">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="#1877F2" xmlns="http://www.w3.org/2000/svg"><path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.469h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.469h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/></svg>
                  Continua cu Facebook
                </button>
                <button
                  onClick={() => setArataFormularEmail(true)}
                  className="w-full flex items-center justify-center gap-3 bg-white border border-[#3a3a44] rounded-lg px-4 py-3 text-[#3a3a44] font-bold hover:bg-[#3a3a44] hover:text-white transition mt-4"
                >
                  Continua cu email
                </button>
              </div>
            </div>
          ) : (
            <div className="animate-fade-in">
              <button
                onClick={() => setArataFormularEmail(false)}
                className="flex items-center text-sm font-bold text-gray-500 hover:text-gray-900 mb-6 transition"
              >
                <svg className="w-4 h-4 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M15 19l-7-7 7-7" /></svg>
                Inapoi la optiuni
              </button>

              <h2 className="text-3xl font-extrabold text-[#3a3a44] text-center mb-8">Inregistrare</h2>
              
              <form className="space-y-4" onSubmit={trimiteDate}>
                <div className="grid grid-cols-2 gap-4">
                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">Prenume</label>
                        <input
                            name="first_name"
                            type="text"
                            required
                            className="w-full px-4 py-3 bg-white border border-gray-300 rounded-lg focus:outline-none focus:border-[#008f9c] focus:ring-1 focus:ring-[#008f9c] transition font-medium"
                            onChange={actualizareDate}
                        />
                    </div>
                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">Nume</label>
                        <input
                            name="last_name"
                            type="text"
                            required
                            className="w-full px-4 py-3 bg-white border border-gray-300 rounded-lg focus:outline-none focus:border-[#008f9c] focus:ring-1 focus:ring-[#008f9c] transition font-medium"
                            onChange={actualizareDate}
                        />
                    </div>
                </div>

                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Adresa de email</label>
                    <input
                        name="email"
                        type="email"
                        required
                        className="w-full px-4 py-3 bg-white border border-gray-300 rounded-lg focus:outline-none focus:border-[#008f9c] focus:ring-1 focus:ring-[#008f9c] transition font-medium"
                        onChange={actualizareDate}
                    />
                </div>
                
                <div className="relative">
                    <label className="block text-sm font-medium text-gray-700 mb-1">Parola</label>
                    <input
                        name="parola"
                        type={arataParola ? 'text' : 'password'}
                        required
                        className="w-full px-4 py-3 bg-white border border-gray-300 rounded-lg focus:outline-none focus:border-[#008f9c] focus:ring-1 focus:ring-[#008f9c] transition font-medium"
                        onChange={actualizareDate}
                    />
                    <button
                        type="button"
                        onClick={() => setArataParola(!arataParola)}
                        className="absolute right-4 bottom-3 text-gray-500 hover:text-gray-700"
                    >
                        {arataParola ? 
                            <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21" /></svg> 
                            : 
                            <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" /><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" /></svg>
                        }
                    </button>
                </div>

                <button
                  type="submit"
                  className="w-full bg-[#3a3a44] text-white py-3 rounded-lg font-bold hover:bg-[#008f9c] transition-colors mt-6"
                >
                  Continua
                </button>
              </form>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default Inregistrare;  